import Header from "./partials/Header";
import Footer from "./partials/Footer";
import Common from "./partials/Common";

import Industry from "./modules/industry";
import MenuServices from "./partials/MenuServices";
import PopupManager from "./modules/popup-manager";

new Header().init();
new Footer().init();
new Common().init();

new Industry().init();
new MenuServices();
new PopupManager();